import { useGTM } from '@hooks/useGTM'
import { FC, ReactElement } from 'react'

export const GTMProvider: FC<{ children: ReactElement }> = ({ children }) => {
  useGTM()

  return children
}
